import type { ReactNode } from "react";
import { FavoritesProvider } from "@/hooks/useFavorites";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <FavoritesProvider>
      <div className="flex min-h-screen flex-col bg-background-100">
        <SiteHeader />
        <main className="flex-1">{children}</main>
        <SiteFooter />
      </div>
    </FavoritesProvider>
  );
}